import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DeliveryStatus, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, PaymentTypeOptions, RentalOptions, RentalStatusOptions, ReturnConditionOptions, TransactionTypeRental, TransactionTypeSales } from "utils/Constant";
import { ApiDeleteProduct, ApiGetOrderSalesById, ApiGetOrderRentalById, ApiOrderRentalDelivered } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { CheckResponse, CheckUndefined, DateLong, GetReturnStatus, GetStatus, money } from "utils/helpers"
import { useModal } from "components/modal/ModalContext";
import { FormCard, PagesFormTitle } from "components/Cards";
import BackButton from "components/Button/BackButton";
import moment from "moment";

export default function TransactionDetail(){
    let navigate = useNavigate()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let orderId = queryString.get("orderId")
    let transactionType = queryString.get("transactionType")

    const {openModal, closeModal} = useModal()

    const { fetch: apiDeleteProduct } = useFetch(ApiDeleteProduct)
    const { fetch: apiGetOrderSales } = useFetch(ApiGetOrderSalesById)
    const { fetch: apiGetOrderRental } = useFetch(ApiGetOrderRentalById)
    const { fetch: apiOrderRentalDelivered } = useFetch(ApiOrderRentalDelivered)

    const [rentalOrder, setRentalOrder] = useState({})
    const [orderDateFrom, setOrderDateFrom] = useState(new Date())
    const [orderDateTo, setOrderDateTo] = useState(new Date())
    const [orderDate, setOrderDate] = useState('')
    const [orderStatus, setOrderStatus] = useState('')
    const [paymentType, setPaymentType] = useState('')
    const [amount, setAmount] = useState('')
    const [discount, setDiscount] = useState('')
    const [nettAmount, setNettAmount] = useState('')
    const [orderDetail, setOrderDetail] = useState([])
    const [status, setStatus] = useState('')
    const [createDate, setCreateDate] = useState('')
    const [createBy, setCreateBy] = useState('')
    const [updateDate, setUpdateDate] = useState('')
    const [updateBy, setUpdateBy] = useState('')

    // Button Event
    const editBtnClick = (id) => {
        navigate("/product/form?productId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = (id, status) => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                deleteProduct(id, status).then((res) => {
                    if (CheckResponse(res)) {
                        
                        closeModal()
                    } else {
                        openModal(ModalTypeFail, { message: res.message })
                    }              
                })
            },
        })
    }
    const deliveredBtnClick = (id) => {
        deliveredRental(id).then((res) => {
            if (CheckResponse(res)) {
                getOrderRental().then((res) => {
                    if (CheckResponse(res)) {
                        let data = res.data

                        setRentalOrder(data)

                        setStatus(data.status)
                        setCreateDate(data.createDate)
                        setCreateBy(data.createBy)
                        setUpdateDate(data.updateDate)
                        setUpdateBy(data.updateBy)
                    } else {
                        openModal(ModalTypeFail, { message: res.message })
                    }
                })
            } else {
                openModal(ModalTypeFail, { message: res.message })
            }
            
        })
    }

    // API Calls
    const getOrderSales = async() => {
        let res = await apiGetOrderSales({
            data: {
                orderId
            }
        })

        return res
    }
    const getOrderRental = async() => {
        let res = await apiGetOrderRental({
            data: {
                rentalOrderId: orderId
            }
        })

        return res
    }
    const deleteProduct = async(productId, status) => {
        let res

        res = await apiDeleteProduct({
            data: {
                productId,
                status
            }
        })

        return res
    }
    const deliveredRental = async() => {
        let res

        res = await apiOrderRentalDelivered({
            data: {
                rentalOrderId: orderId
            }
        })

        return res
    }

    // Function Grid

    useEffect(() => {
        if (transactionType === TransactionTypeSales) {
            getOrderSales().then((res) => {
                if (CheckResponse(res)) {
                    let header = res.data.header
                    let detail = res.data.detail

                    setOrderDate(header.orderDate)
                    setOrderStatus(header.orderStatus)
                    setPaymentType(header.paymentType)
                    setAmount(header.amount)
                    setDiscount(header.discount)
                    setNettAmount(header.nettAmount)

                    setStatus(header.status)
                    setCreateDate(header.createDate)
                    setCreateBy(header.createBy)
                    setUpdateDate(header.updateDate)
                    setUpdateBy(header.updateBy)

                    setOrderDetail(detail)
                } else {
                    openModal(ModalTypeFail, { message: res.message })
                }
            })
        } else if (transactionType === TransactionTypeRental) {
            getOrderRental().then((res) => {
                if (CheckResponse(res)) {
                    let data = res.data

                    setRentalOrder(data)

                    setStatus(data.status)
                    setCreateDate(data.createDate)
                    setCreateBy(data.createBy)
                    setUpdateDate(data.updateDate)
                    setUpdateBy(data.updateBy)
                } else {
                    openModal(ModalTypeFail, { message: res.message })
                }
            })
        }
        
    },[orderDateFrom, orderDateTo, status])

    return(
        <div className="flex flex-col gap-2 p-2 sm:p-6">
            <PagesFormTitle 
                title='Transaction Detail' 
                formType={formType}
                status={status}
                createDate={createDate}
                updateDate={updateDate}
                updateBy={updateBy}
            />

            {transactionType === TransactionTypeSales ? (
                <div>
                    <div className="bg-white rounded-xl p-3 shadow-md">
                        <div className="mb-3">
                            <span className="text-xl font-semibold">Order Detail</span>
                        </div>
                        
                        <FormCard title='Transaction Date'>
                            <span>{moment(orderDate).format('DD MMMM YYYY')}</span>
                        </FormCard>
                        <FormCard title='Payment Type'>
                            <span>{ paymentType !== '' ? PaymentTypeOptions.find(x => x.value === paymentType).label : '' }</span>
                        </FormCard>
                        <FormCard title='Amount'>
                            <span>Rp { money(amount) }</span>
                        </FormCard>
                        <FormCard title='Discount'>
                            <span>{ discount } %</span>
                        </FormCard>
                        <FormCard title='Nett Amount'>
                            <span>Rp { money(nettAmount) }</span>
                        </FormCard>
                    </div>
                    
                    <div className="bg-white rounded-xl shadow-md p-3 mt-4">
                        <span className="text-xl font-semibold">Product Detail</span>

                        <div className="mt-5 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm">
                            <table className="w-full border bg-white">
                                <thead>
                                    <tr className="h-12">
                                        <th className="font-semibold w-16">No</th>
                                        <th className="font-semibold text-left px-2">Stock Code</th>
                                        <th className="font-semibold text-left px-2">Product Name</th>
                                        <th className="font-semibold text-left px-2">Amount</th>
                                        <th className="font-semibold text-left px-2">Discount</th>
                                        <th className="font-semibold text-left px-2">Tax</th>
                                        <th className="font-semibold text-left px-2">Nett Amount</th>
                                        <th className="font-semibold text-left px-2">Return</th>
                                        <th className="font-semibold text-left px-2">Remark</th>
                                    </tr>
                                </thead>
                                <tbody className="border">
                                    { orderDetail?.length === 0 && (
                                        <tr className="text-center h-12">
                                        <td colSpan={8}>No Data Available</td> 
                                        </tr>
                                    )}
                                    { orderDetail?.map((data, i) => {
                                        return(
                                            <tr className="my-2 row h-10 border-y hover:bg-slate-100 cursor-pointer" key={ i }
                                                
                                            >
                                                <td className="text-center">{ i + 1 }</td>
                                                <td className="px-2">
                                                    <span>{ data.stockCode }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>{ data.brandName + ' ' + data.productName } { data.size !== '' ? 'Size ' + data.size : ''}</span>
                                                </td>
                                                <td className="px-2 text-right">
                                                    <span>Rp { money(data.price) }</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>{ data.discount } %</span>
                                                </td>
                                                <td className="px-2">
                                                    <span>{ data.tax } %</span>
                                                </td>
                                                <td className="px-2 text-right">
                                                    <span>Rp { money(data.nettPrice) }</span>
                                                </td>
                                                <td className="px-2 hidden sm:table-cell">
                                                    <span>{ GetReturnStatus(data.isReturn) }</span>
                                                </td>
                                                <td className="px-2 hidden sm:table-cell">
                                                    <span>{ data.remark === '' ? '-' : data.remark }</span>
                                                </td>
                                                <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                                    <button className="bg-black text-white flex items-center gap-2 px-3 py-1 rounded-lg" 
                                                        onClick={() => editBtnClick(data.productId)}
                                                    >
                                                        <span className="text-sm">Return</span>
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr className="h-11">
                                        <td colSpan={6} className="text-right px-2">
                                            <span className="font-semibold">Total</span>
                                        </td>
                                        <td colSpan={1} className="px-2 text-right">
                                            <span className="font-semibold">
                                                Rp { money(String(orderDetail?.reduce((sum, item) => sum + Number(item.nettPrice || 0), 0))) }
                                            </span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="bg-white border rounded-xl p-3 mt-2">
                    <div className="mb-3">
                        <span className="text-xl font-semibold">Rental Detail</span>
                    </div>

                    <div>
                        <FormCard title='Customer Name'>
                            <span>{ rentalOrder.customerName }</span>
                        </FormCard>
                        <FormCard title='Rental Date'>
                            <span>{ moment(rentalOrder.rentalDate).format('DD MMMM YYYY - HH:mm') }</span>
                        </FormCard>
                        <FormCard title='Product'>
                            <span>{ rentalOrder.brandName } { rentalOrder.productName}</span>
                        </FormCard>
                        <FormCard title='Duration'>
                            <span>{ rentalOrder.quantity } { CheckUndefined(rentalOrder.rentalOptions) ? RentalOptions.find(x => x.value === rentalOrder.rentalOptions).label : '' }</span>
                        </FormCard>
                        <FormCard title='Delivery Date'>
                            <span>{ moment(rentalOrder.deliveryDate).format('DD MMMM YYYY - HH:mm') }</span>
                        </FormCard>
                        <FormCard title='Delivery Status'>
                            <div className="flex gap-8 items-center">
                                <span>{ CheckUndefined(rentalOrder.deliveryStatus) ? DeliveryStatus.find(x => x.value === rentalOrder.deliveryStatus).label : '' }</span>
                                {rentalOrder.deliveryStatus === '1' && (
                                    <button className="bg-black text-white px-2 py-1 rounded-lg text-sm"
                                        onClick={deliveredBtnClick}
                                    >
                                        <span>Delivered</span>
                                    </button>
                                )}
                            </div>
                        </FormCard>
                        <FormCard title='Delivery Location'>
                            <span>{ rentalOrder.deliveryLocation }</span>
                        </FormCard>
                        <FormCard title='Rental Amount'>
                            <span>Rp { money(rentalOrder.amount) }</span>
                        </FormCard>
                        <FormCard title='Discount'>
                            <span>{ rentalOrder.discount } %</span>
                        </FormCard>
                        <FormCard title='Delivery Fee'>
                            <span>Rp { money(rentalOrder.deliveryFee) }</span>
                        </FormCard>
                        <FormCard title='Nett Amount'>
                            <span className="font-semibold">Rp { money(rentalOrder.nettAmount) }</span>
                        </FormCard>
                        <FormCard title='Rental Status'>
                            <span>{ CheckUndefined(rentalOrder.isReturned) ? RentalStatusOptions.find(x => x.value === rentalOrder.isReturned).label : '' }</span>
                        </FormCard>
                        <FormCard title='Payment'>
                            <span>{ CheckUndefined(rentalOrder.paymentType) ? PaymentTypeOptions.find(x => x.value === rentalOrder.paymentType).label : '' }</span>
                        </FormCard>
                        <FormCard title='Return Date'>
                            <span>{ moment(rentalOrder.returnDate).format('DD-MM-YY') === '01-01-01' ? 'Not Returned Yet' : moment(rentalOrder.returnDate).format('DD MMMM YYYY - HH:mm') }</span>
                        </FormCard>
                        <FormCard title='Return Condition'>
                            <span>{ CheckUndefined(rentalOrder.returnedCondition) ? ReturnConditionOptions.find(x => x.value === rentalOrder.returnedCondition).label : '' }</span>
                        </FormCard>
                        <FormCard title='Return Notes'>
                            <span>{ rentalOrder.returnedNotes }</span>
                        </FormCard>
                    </div>
                </div>
            )}
            
            

            <div className="flex justify-end mt-4">
                <BackButton onClick={() => { navigate('/transaction') }} />
            </div>
        </div>
    )
}
